/* KZK Hesaba Özel Sepet Senkronizasyonu
 *
 * Sepet içeriği tarayıcı çerezinde değil, müşteri hesabına (email) bağlı backend'de
 * tutulur. Böylece hesap hangi cihaz/tarayıcıda açılırsa açılsın kendi sepeti gelir.
 *
 * - GİRİŞ / sayfa yükleme: backend sepeti çekilir; Shopify sepeti ondan FARKLIYSA
 *   backend uygulanır (backend = doğru kaynak; her değişim anında oraya yazılır).
 * - DEĞİŞİM: /cart/add|change|update|clear sonrası Shopify sepeti okunup backend'e yazılır.
 * - ÇIKIŞ: Shopify sepeti temizlenir (aynı tarayıcıda sonraki hesap karışmasın).
 *
 * Misafir sepete ekleyemez (giriş şart) -> birleştirme mantığı yok.
 * NOT: kzk-auth.js'ten SONRA yüklenmeli (KzkAuth API + logout sarmalama için).
 */
(function () {
  'use strict';

  var API = (window.KzkAuth && window.KzkAuth.apiBase) || window.KZK_API_BASE || 'https://senko.toserof.com';
  var CART_URL = API + '/api/storefront-cart';
  var _applying = false;   // backend'den Shopify'a yazarken kendi yazımımızı geri push etme
  var _pushTimer = null;

  function token() { return (window.KzkAuth && window.KzkAuth.getToken && window.KzkAuth.getToken()) || ''; }
  function loggedIn() { return !!token(); }

  function getShopifyCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  // Karşılaştırma anahtarı (id + adet, sıradan bağımsız)
  function itemsKey(items) {
    return (items || []).map(function (i) { return (i.id != null ? i.id : i.variant_id) + ':' + i.quantity; }).sort().join('|');
  }

  /* Bu sekmede backend'e henuz gonderilmemis sepet degisikligi var mi.
     Sayfa yenilenmesinden sonra da bilinmesi gerektigi icin sessionStorage'da tutulur. */
  var BEKLEYEN = 'kzkCartPendingPush';
  function bekleyenIsaretle() { try { sessionStorage.setItem(BEKLEYEN, '1'); } catch (e) {} }
  function bekleyenTemizle() { try { sessionStorage.removeItem(BEKLEYEN); } catch (e) {} }
  function bekleyenVar() { try { return sessionStorage.getItem(BEKLEYEN) === '1'; } catch (e) { return false; } }

  /* Shopify sepetini backend'e yaz. keepalive: sayfa kapanirken/yonlenirken de gitsin. */
  function gonder(keepalive) {
    if (_applying || !loggedIn()) return Promise.resolve();
    return getShopifyCart().then(function (cart) {
      var items = (cart.items || []).map(function (i) {
        var o = { id: i.id, quantity: i.quantity };
        if (i.properties && Object.keys(i.properties).length) o.properties = i.properties;
        return o;
      });
      return fetch(CART_URL, {
        method: 'PUT',
        keepalive: !!keepalive,
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token() },
        body: JSON.stringify({ items: items })
      });
    }).then(function (r) {
      if (r && r.ok) bekleyenTemizle();
    }).catch(function () { /* sessiz - sepet yine Shopify'da çalışır */ });
  }

  /* Shopify sepetini backend'e yaz (debounced) */
  function pushToBackend(hemen) {
    if (_applying || !loggedIn()) return;
    bekleyenIsaretle();
    if (_pushTimer) { clearTimeout(_pushTimer); _pushTimer = null; }
    if (hemen) return gonder(true);
    _pushTimer = setTimeout(function () {
      _pushTimer = null;
      gonder(false);
    }, 400);
  }

  /* Backend sepetini Shopify'a uygula (temizle + toplu ekle) */
  function applyToShopify(items) {
    _applying = true;
    return fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
      .then(function () {
        if (!items || !items.length) return null;
        var payload = {
          items: items.map(function (i) {
            var o = { id: i.id, quantity: i.quantity };
            if (i.properties && Object.keys(i.properties).length) o.properties = i.properties;
            return o;
          })
        };
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
      })
      .then(function () {
        try { document.dispatchEvent(new CustomEvent('cart-drawer:refresh')); } catch (e) {}
        try { window.dispatchEvent(new CustomEvent('kzk:cart-synced')); } catch (e) {}
      })
      .catch(function () { /* stok dışı satır vb. -> kısmi; sessiz geç */ })
      .finally(function () { _applying = false; });
  }

  /* Giriş / sayfa yükleme: backend doğru kaynak; Shopify ondan farklıysa eşitle */
  var _syncing = false;
  function syncFromBackend() {
    if (_syncing || !loggedIn()) return;
    // Bu sekmede henuz gonderilememis bir degisiklik varsa dogru olan yerel sepettir.
    // Aksi halde backend'deki eski kopya geri yazilip silinen urun geri geliyordu.
    if (bekleyenVar()) { pushToBackend(true); return; }
    _syncing = true;
    Promise.all([
      fetch(CART_URL, { headers: { 'Authorization': 'Bearer ' + token() } }).then(function (r) { return r.ok ? r.json() : null; }),
      getShopifyCart()
    ]).then(function (res) {
      var backend = res[0], shopify = res[1];
      if (!backend || !backend.ok) return;
      if (itemsKey(backend.items) === itemsKey(shopify.items)) return; // aynı -> dokunma
      // Backend'i Shopify'a uygula. Sepet gerçekten değiştiyse (ve TAM senkron olduysa)
      // cart drawer/header'ı kesin güncellemek için sayfayı BİR kez yenile. Yenileme
      // sonrası backend==shopify olacağından tekrar yenilenmez (döngü yok). Stok-dışı
      // ürün nedeniyle tam senkron olmazsa yenileme yapılmaz (sonsuz döngü önlenir).
      return applyToShopify(backend.items).then(function () {
        return getShopifyCart().then(function (after) {
          if (itemsKey(after.items) === itemsKey(backend.items)) {
            window.location.reload();
          }
        });
      });
    }).catch(function () {}).finally(function () { _syncing = false; });
  }

  /* Çıkış: Shopify sepetini temizle (backend'deki hesap sepeti korunur) */
  function clearShopifyCart() {
    _applying = true;
    try {
      // sendBeacon: redirect gerçekleşse bile istek gider
      if (navigator.sendBeacon) {
        navigator.sendBeacon('/cart/clear.js');
      } else {
        fetch('/cart/clear.js', { method: 'POST', keepalive: true });
      }
    } catch (e) {}
    setTimeout(function () { _applying = false; }, 1500);
  }

  /* --- Cart yazma isteklerini yakala (fetch interception) --- */
  var _origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = (typeof input === 'string') ? input : (input && input.url) || '';
    var isWrite = /\/cart\/(add|change|update|clear)(\.js)?(\?|$|#)/.test(url);
    var p = _origFetch.apply(this, arguments);
    if (isWrite && !_applying) {
      p.then(function (res) { if (res && res.ok) pushToBackend(); }).catch(function () {});
    }
    return p;
  };

  /* Sayfa kapanirken/gizlenirken bekleyen gonderimi bekletme */
  function bekleyeniBosalt() {
    if (_pushTimer) { clearTimeout(_pushTimer); _pushTimer = null; }
    if (bekleyenVar()) gonder(true);
  }
  window.addEventListener('pagehide', bekleyeniBosalt);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') bekleyeniBosalt();
  });

  /* --- Auth olayları --- */
  window.addEventListener('kzk:auth-ready', function (e) {
    if (e.detail && e.detail.user) syncFromBackend();
  });

  // logout'u sarmala -> Shopify sepetini temizle, sonra normal çıkış
  if (window.KzkAuth && typeof window.KzkAuth.logout === 'function') {
    var _origLogout = window.KzkAuth.logout;
    window.KzkAuth.logout = function () {
      clearShopifyCart();
      return _origLogout.apply(this, arguments);
    };
  }

  // Boot: zaten girişliyse hemen eşitle
  if (loggedIn()) syncFromBackend();
})();
